import {Injectable} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';

@Injectable({
  providedIn: 'root'
})
export class ComboBoxService {

  constructor(private crud: CrudService,
              private spring: Spring) {
  }

  getListSaregfis() {
    return this.crud.get(`${this.spring.SAREGFIS_GET_LIST}`);
  }

  getListGlnacion() {
    return this.crud.get(`${this.spring.GLNACION_GET_LIST}`);
  }

  getListGlbancos() {
    return this.crud.get(`${this.spring.GLBANCOS_GET_LIST}`);
  }

  getListGltipdom() {
    return this.crud.get(`${this.spring.GLTIPDOM_GET_LIST}`);
  }

  getListCtestatu() {
    return this.crud.get(`${this.spring.CTESTATU_GET_LIST}`);
  }

  getListGltippol() {
    return this.crud.get(`${this.spring.GLTIPPOL_GET_LIST}`);
  }

  getListGltipcla() {
    return this.crud.get(`${this.spring.GLTIPCLA_GET_LIST}`);
  }

  getListCtperpla() {
    return this.crud.get(`${this.spring.CTPERPLA_GET_LIST}`);
  }

  getListGltipint() {
    return this.crud.get(`${this.spring.GLTIPINT_GET_LIST}`);
  }

  getListGltipper() {
    return this.crud.get(`${this.spring.GLTIPPER_GET_LIST}`);
  }

  getListPvtippro() {
    return this.crud.get(`${this.spring.PVTIPPRO_GET_LIST}`);
  }

  getListPvtipcon() {
    return this.crud.get(`${this.spring.PVTIPCON_GET_LIST}`);
  }

  getListGlasentaByCodigoPostal(codigoPostal: number) {
    return this.crud.get(`${this.spring.GLSENTA_GET_LIST_BY_CP}${codigoPostal}`);
  }

  getGlasentaById(idasenta: number) {
    return this.crud.get(`${this.spring.GLSENTA_GET_LIST_BY_ID}${idasenta}`);
  }

  getListGltipadjByTabla(tabla: string, id: number, filtro: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_TABLA}${tabla}&${id}&${filtro}`);
  }

  getListGltipadj(tipo: string, id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST}${tipo}&${id}`);
  }

  getListGltipadjByInpatrim(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_INPATRIM}${id}`);
  }


  getListGltipadjByInpatinm(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_INPATINM}${id}`);
  }

  getListGltipadjByPrepagos(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_PREPAGOS}${id}`);
  }

  getListGltipadjByCtcontra(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_CTCONTRA}${id}`);
  }


  getListGltipadjByCtconven(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_CTCONVEN}${id}`);
  }

  getListGltipadjByInseguro() {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_INSEGURO}`);
  }

  getListGltipadjByInseguroPagos(idseguro: number, fechaUltimoPagoPoliza: string) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_INSEGURO_PAGOS}${idseguro}&${fechaUltimoPagoPoliza}`);
  }

  getListGltipadjByLilicenc() {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_LILICENC}`);
  }

  getListGltipadjByRqgenral() {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_RQGENRAL}`);
  }

  getListGltipadjByCpmovimi(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_CPMOVIMI}${id}`);
  }

  getListGltipadjByCggasdet(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_CGGASDET}${id}`);
  }

  getListGltipadjByLeacuses(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_LEACUSES}${id}`);
  }

  getListGltipadjByPsinfgen() {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_BY_PSINFGEN}`);
  }


  getListSausocfd() {
    return this.crud.get(`${this.spring.SAUSOCFD_GET_LIST}`);
  }

  getListSaforpag() {
    return this.crud.get(`${this.spring.SAFORPAG_GET_LIST}`);
  }

  getListSaforpagCXP() {
    return this.crud.get(`${this.spring.SAFORPAG_GET_LIST_CXP}`);
  }

  getListSametpag() {
    return this.crud.get(`${this.spring.SAMETPAG_GET_LIST}`);
  }

  getListGltipmon() {
    return this.crud.get(`${this.spring.GLTIPMON_GET_LIST}`);
  }

  getListGlarrend() {
    return this.crud.get(`${this.spring.GLARREND_GET_LIST}`);
  }

  getListGlparcia() {
    return this.crud.get(`${this.spring.GLPARCIA_GET_LIST}`);
  }

  getListGlmovcon() {
    return this.crud.get(`${this.spring.GLMOVCON_GET_LIST}`);
  }


  getListSatipexp() {
    return this.crud.get(`${this.spring.SATIPEXP_GET_LIST}`);
  }

  getListSatipcom() {
    return this.crud.get(`${this.spring.SATIPCOM_GET_LIST}`);
  }

  getListSatipcomGeneral() {
    return this.crud.get(`${this.spring.SATIPCOM_GET_LIST_GENERAL}`);
  }


  getListSaproser() {
    return this.crud.get(`${this.spring.SAPROSER_GET_LIST}`);
  }

  getListSaunimed() {
    return this.crud.get(`${this.spring.SAUNIMED_GET_LIST}`);
  }

  getListSaobjimp() {
    return this.crud.get(`${this.spring.SAOBJIMP_GET_LIST}`);
  }

  getListSatipfac() {
    return this.crud.get(`${this.spring.SATIPFAC_GET_LIST}`);
  }

  getListSatiprel() {
    return this.crud.get(`${this.spring.SATIPREL_GET_LIST}`);
  }

  getListPrestatu() {
    return this.crud.get(`${this.spring.PRESTATU_GET_LIST}`);
  }

  getListPspersonByUsuarioFD() {
    return this.crud.get(`${this.spring.PSPERSON_GET_LIST_BY_USUARIOFD}`);
  }

  getListPsdomiciFacturacionByIdperson(idperson: number) {
    return this.crud.get(`${this.spring.PSDOMICI_FACTURACION_GET_LIST_BY_IDPERSON}${idperson}`);
  }

  getListRffacfolByIdpersonAndIdtipcom(idpersonLocal: number, idpersonCliente: number, idtipcom: number) {
    return this.crud.get(`${this.spring.RFFACFOL_GET_LIST_BY_IDPERSON_IDTIPCOM}${idpersonLocal}&${idpersonCliente}&${idtipcom}`);
  }

  getListInpatrimGroupByIdperson() {
    return this.crud.get(`${this.spring.INPATRIM_GET_LIST_GROUPBY_IDPERSON}`);

  }

  getListPspersonHasRffactur() {
    return this.crud.get(`${this.spring.PSPERSON_GET_LIST_HAS_RFFACTUR}`);
  }

  getListInsegcla() {
    return this.crud.get(`${this.spring.INSEGCLA_GET_LIST}`);
  }

  getListGlasegur() {
    return this.crud.get(`${this.spring.GLASEGUR_GET_LIST}`);
  }

  getListIntippol() {
    return this.crud.get(`${this.spring.INTIPPOL_GET_LIST}`);
  }

  getListInfrepag() {
    return this.crud.get(`${this.spring.INFREPAG_GET_LIST}`);
  }


  getListInvmarca() {
    return this.crud.get(`${this.spring.INVMARCA_GET_LIST}`);
  }

  getListIntiptra() {
    return this.crud.get(`${this.spring.INTIPTRA_GET_LIST}`);
  }

  getListUsusuari() {
    return this.crud.get(`${this.spring.USUSUARI_GET_LIST}`);
  }

  getListGlmoneda() {
    return this.crud.get(`${this.spring.GLMONEDA_GET_LIST}`);
  }

  getListLilictip() {
    return this.crud.get(`${this.spring.LILICTIP_GET_LIST}`);
  }

  getListCtfactip() {
    return this.crud.get(`${this.spring.CTFACTIP_GET_LIST}`);
  }

  getListPvprovee() {
    return this.crud.get(`${this.spring.PVPROVEE_GET_LIST}`);
  }

  getListPvproveeActivos() {
    return this.crud.get(`${this.spring.PVPROVEE_GET_LIST_ACTIVOS}`);
  }

  getListRqtipart() {
    return this.crud.get(`${this.spring.RQTIPART_GET_LIST}`);
  }

  getListRqarticu() {
    return this.crud.get(`${this.spring.RQARTICU_GET_LIST}`);
  }

  getListUsdepart() {
    return this.crud.get(`${this.spring.USDEPART_GET_LIST}`);
  }

  getListSamotcan() {
    return this.crud.get(`${this.spring.SAMOTCAN_GET_LIST}`);
  }

  getListGlacteco() {
    return this.crud.get(`${this.spring.GLACTECO_GET_LIST}`);
  }

  getListGlgirome() {
    return this.crud.get(`${this.spring.GLGIROME_GET_LIST}`);
  }

  getListGledociv() {
    return this.crud.get(`${this.spring.GLEDOCIV_GET_LIST}`);
  }

  getListGlregcon() {
    return this.crud.get(`${this.spring.GLREGCON_GET_LIST}`);
  }

  getListGltipide() {
    return this.crud.get(`${this.spring.GLTIPIDE_GET_LIST}`);
  }

  getListGladmsoc() {
    return this.crud.get(`${this.spring.GLADMSOC_GET_LIST}`);
  }

  getListGltipter() {
    return this.crud.get(`${this.spring.GLTIPTER_GET_LIST}`);
  }

  getListGltipinm() {
    return this.crud.get(`${this.spring.GLTIPINM_GET_LIST}`);
  }

  getListPspersonGeneral() {
    return this.crud.get(`${this.spring.PSPERSON_GET_LIST_GENERAL}`);
  }

  getListEmpagest() {
    return this.crud.get(`${this.spring.EMPAGEST_GET_LIST}`);
  }

  getListGltipimp() {
    return this.crud.get(`${this.spring.GLTIPIMP_GET_LIST}`);
  }

  getListRftipope() {
    return this.crud.get(`${this.spring.RFTIPOPE_GET_LIST}`);
  }

  getListPsempusuByIdusuari() {
    return this.crud.get(`${this.spring.PSEMPUSU_GET_LIST_BY_IDUSUARI}`);
  }

  getListGlproyec() {
    return this.crud.get(`${this.spring.GLPROYEC_GET_LIST}`);
  }


  getListGlrecpag() {
    return this.crud.get(`${this.spring.GLRECPAG_GET_LIST}`);
  }

  getListGltipcom() {
    return this.crud.get(`${this.spring.GLTIPCOM_GET_LIST}`);
  }

  getlistGltipope() {
    return this.crud.get(`${this.spring.GLTIPOPE_GET_LIST}`);
  }

  getListUscuebanByIdusuari(idusuari: number) {
    return this.crud.get(`${this.spring.USCUEBAN_GET_LIST_BY_IDUSUARI}${idusuari}`);
  }

  getListCggastip() {
    return this.crud.get(`${this.spring.CGGASTIP_GET_LIST}`);
  }

  getListCgestatu() {
    return this.crud.get(`${this.spring.CGESTATU_GET_LIST}`);
  }

  getListSaproaroByTransporte() {
    return this.crud.get(`${this.spring.SAPROARO_GET_LIST_BY_TRANSPORTE}`);
  }

  getListSaproaroByAlimentos() {
    return this.crud.get(`${this.spring.SAPROARO_GET_LIST_BY_ALIMENTOS}`);
  }

  getListSaproaroByHotel() {
    return this.crud.get(`${this.spring.SAPROARO_GET_LIST_BY_HOTEL}`);
  }

  getListLetipact() {
    return this.crud.get(`${this.spring.LETIPACT_GET_LIST}`);
  }

  getListLetipper() {
    return this.crud.get(`${this.spring.LETIPPER_GET_LIST}`);
  }

  getListUsbuscarByIdusuari(idusuari: number) {
    return this.crud.get(`${this.spring.USBUSCAR_GET_LIST_BY_IDUSUARI}${idusuari}`);
  }

  getListUpplugin() {
    return this.crud.get(`${this.spring.UPPLUGIN_GET_LIST}`);
  }


}
